import { useEffect, useState } from 'react';
import { useOrganizationStore } from './state/OrganizationContainer';

const excludedIds = [
    '9760cf0c-fa0a-4023-8822-54c8d2112fd7',
    '9e87110e-cd07-4025-ae8b-db9f9840758e',
    '0887b18e-fb6b-4a2a-92cf-8641e1d19485',
    '2cf82a34-a1ee-44cf-98ce-9fe6e09756fd',
];

const toPascalCase = (str: string): string => {
    return str
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
};

export function useScopes() {
    const [error, setError] = useState<boolean>(false);
    const scopes = useOrganizationStore((state) => state.scopes);
    const loadingData = useOrganizationStore((state) => state.loadingData);
    const { getScopes: fetchScopes, setScopes, handleLoadingDataChange } = useOrganizationStore.getState();

    useEffect(() => {
        const getScopes = async () => {
            try {
                handleLoadingDataChange('scopes', true);
                const data = await fetchScopes();

                // Filter out excluded IDs, then map and sort the data alphabetically by label
                const sortedScopes = data
                    .filter((scope) => !excludedIds.includes(scope.id))
                    .map((scope) => ({
                        label: toPascalCase(scope.name),
                        value: scope.id,
                        description: scope.description,
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label));

                setScopes(sortedScopes);
                setError(false);
            } catch (err) {
                setError(true);
            } finally {
                handleLoadingDataChange('scopes', false);
            }
        };
        if (scopes.length === 0) {
            getScopes();
        }
    }, []);

    return { scopes, loading: loadingData.scopes, error };
}
